import { Box } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import SkeletonWrapper from './SkeletonWrapper';
import useMobile from 'services/Hooks/useMobile';

const useStyles = makeStyles(theme => ({
  selectedImg: {
    borderStyle: 'solid',
    border: `1px ${theme.palette.secondary.main}`,
    maxWidth: '10vh',
    maxHeight: '10vh',
    marginRight: '1vh',
  },
  imgPreview: {
    borderStyle: 'solid',
    border: '1px black',
    maxWidth: '10vh',
    maxHeight: '10vh',
    marginRight: '1vh',
    '&:hover': {
      border: '1px gray',
      cursor: 'pointer',
    },
  },
}));

const ImagesSlideView = ({ images, getImageUrl, isLoading, onUpdateImage, defaultImage }) => {
  const classes = useStyles();
  const [selectedImg, setSelectedImg] = useState();

  const isMobile = useMobile();

  const handleUpdateImage = useCallback(
    img => {
      setSelectedImg(img);

      if (onUpdateImage) {
        onUpdateImage(img);
      }
    },
    [onUpdateImage],
  );

  useEffect(() => {
    if (images?.length > 0) {
      handleUpdateImage(images.find(i => i.dealerPortalPrimary) ?? images[0]);
    } else {
      handleUpdateImage(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleUpdateImage, images]);

  return (
    <SkeletonWrapper
      isLoading={isLoading}
      fullWidth
      variant="rectangular"
      component={
        <>
          <Box display="flex" justifyContent="center" alignItems="center" sx={{ ml: 20, mr: 20 }}>
            <img
              src={
                images?.length > 0
                  ? getImageUrl(selectedImg ? selectedImg?.id : images[0]?.id)
                  : defaultImage
                  ? defaultImage
                  : '/images/brp-logo.png'
              }
              alt="Header"
              style={isMobile ? { maxHeight: '65vh' } : { height: '65vh' }}
            />
          </Box>

          {images?.length > 1 && (
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ ml: 20, mr: 20, mt: 2 }}>
              {images?.map(img => (
                <Box>
                  <img
                    className={selectedImg?.id === img?.id ? classes.selectedImg : classes.imgPreview}
                    src={images?.length > 0 ? getImageUrl(img?.id) : defaultImage ? defaultImage : '/images/brp-logo.png'}
                    onClick={() => handleUpdateImage(img)}
                    alt="Header"
                    style={{ height: '65vh' }}
                  />
                </Box>
              ))}
            </Box>
          )}
        </>
      }
    />
  );
};

export default ImagesSlideView;
